var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lightbox-overlay",
      attrs: {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": _vm.fileName
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "lightbox-content" }, [
        _c("div", { staticClass: "lightbox-toolbar" }, [
          _c("div", { staticClass: "lightbox-title" }, [
            _c(
              "span",
              { staticClass: "lightbox-file-icon" },
              [
                _c("portal-icon", {
                  attrs: { name: _vm.isPdf ? "file-text" : "eye", size: 18 }
                })
              ],
              1
            ),
            _c("span", [_vm._v(_vm._s(_vm.fileName))])
          ]),
          _c(
            "button",
            {
              staticClass: "close-button",
              attrs: { type: "button", "aria-label": _vm.$t("global.close") },
              on: { click: _vm.close }
            },
            [_c("portal-icon", { attrs: { name: "x", size: 20 } })],
            1
          )
        ]),
        _vm.isPdf
          ? _c("div", { staticClass: "pdf-container" }, [
              _c("iframe", { attrs: { src: _vm.url, title: _vm.fileName } })
            ])
          : _c("div", { staticClass: "image-container" }, [
              _c("img", { attrs: { src: _vm.url, alt: _vm.fileName } })
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }